import { RequestBase } from './RequestBase';

export class RequestLogin extends RequestBase {
    UserName: string;
    Password: string;
    UserCategory: number;
}